module.exports = __webpack_public_path__ + "img/stock5.a721f115.png";